const Single = () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/Companies/Single')
const Search = () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/Companies/Search')

export default [
  {
    path: 'companies/create',
    name: 'CompaniesCreate',
    component: Single,
    meta: {
      title: 'Adicionar Empresa',
      ensureCanSeeFunctionalities: true,
      permission: {
        name: 'companies',
        action: 'create'
      }
    }
  },
  {
    path: 'companies/:id',
    name: 'CompaniesEdit',
    component: Single,
    meta: {
      title: 'Editar Empresa',
      ensureCanSeeFunctionalities: true,
      permission: {
        name: 'companies',
        action: 'read'
      }
    }
  },
  {
    path: 'companies',
    name: 'CompaniesSearch',
    component: Search,
    meta: {
      title: 'Empresas',
      ensureCanSeeFunctionalities: true,
      permission: {
        name: 'companies',
        action: 'read'
      }
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/dashboard/companies.js